module.exports = __webpack_public_path__ + "static/media/amarelo.26e05aea.svg";